import { NgClass } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-big-dots-spinner',
  templateUrl: './big-dots-spinner.component.html',
  styleUrls: ['./big-dots-spinner.component.scss'],
  imports: [NgClass],
})
export class BigDotsSpinnerComponent {
  fullScreen: InputSignal<boolean> = input.required();
  loading: InputSignal<boolean> = input.required();
}
